import React from 'react'
import { Document, Page } from 'react-pdf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCircleXmark } from '@fortawesome/free-solid-svg-icons'

// URL berkas bisa membawa query string, jadi ekstensinya diambil dari path saja.
const extensionOf = (src = '') => {
  const path = String(src).split('?')[0].split('#')[0].toLowerCase()
  const dot = path.lastIndexOf('.')
  return dot === -1 ? '' : path.slice(dot + 1)
}

export const isImageFile = (src) =>
  ['jpg', 'jpeg', 'png', 'webp'].includes(extensionOf(src))

export const isPdfFile = (src) => extensionOf(src) === 'pdf'

// Logo miring di tengah berkas: menandai bahwa gambar diambil dari dashboard.
const Watermark = ({ height, width }) => (
  <div
    className="absolute z-10 pointer-events-none"
    style={{
      height: height / 1.4,
      width: width / 1.4,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(325deg)',
      backgroundImage: 'url(/logo.png)',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      filter: 'grayscale(100%)',
      opacity: 0.2,
    }}
  />
)

/**
 * Menampilkan satu berkas registrasi (gambar atau halaman pertama PDF)
 * lengkap dengan watermark. Dipakai untuk thumbnail di detail pendaftar
 * maupun tampilan besar di PreviewModal.
 */
const FilePreview = ({ src, height = 280, width = 280, className = '' }) => {
  if (!src) {
    return null
  }

  if (isImageFile(src)) {
    return (
      <div
        className={`relative mx-auto ${className}`}
        style={{
          height,
          width,
          backgroundImage: `url(${src})`,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Watermark height={height} width={width} />
      </div>
    )
  }

  if (isPdfFile(src)) {
    return (
      <div
        className={`relative flex justify-center items-center ${className}`}
        style={{ height }}
      >
        <Document file={src}>
          <Page
            height={height}
            pageNumber={1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
        <Watermark height={height} width={width} />
      </div>
    )
  }

  // Format lain tetap bisa dibuka lewat tautan, tidak dibiarkan kosong.
  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 text-muted ${className}`}
      style={{ height }}
    >
      <FontAwesomeIcon icon={faFileCircleXmark} className="text-xl" />
      <span className="text-[13px]">Format tidak bisa ditampilkan</span>
      <a
        className="text-[13px] font-semibold text-accent underline"
        href={src}
        target="_blank"
        rel="noreferrer"
      >
        Buka berkas
      </a>
    </div>
  )
}

export default FilePreview
